const items = state => state.items.data
const error = state => state.error
const isLoading = state => state.isLoading
const isDownloading = state => state.isDownloading
const errorDownloading = state => state.errorDownloading
const item = state => state.item.data
const count = state => {
  let arr = state.items.data
  if (arr) {
    let obj = {
      payment: arr.length
    }

    return obj
  }
}

const unpaidFilter = state => state.unpaidFilter.data
const errorUnpaidFilter = state => state.errorUnpaidFilter
const isLoadingUnpaidFilter = state => state.isLoadingUnpaidFilter

const paymentWaiting = state => state.paymentWaiting.data
const errorpaymentWaiting = state => state.errorpaymentWaiting
const isLoadingpaymentWaiting = state => state.isLoadingpaymentWaiting

const paymentPartial = state => state.paymentPartial.data
const errorpaymentPartial = state => state.errorpaymentPartial
const isLoadingpaymentPartial = state => state.isLoadingpaymentPartial

const paymentComplete = state => state.paymentComplete.data
const errorpaymentComplete = state => state.errorpaymentComplete
const isLoadingpaymentComplete = state => state.isLoadingpaymentComplete

const createPayment = state => state.createPayment.data
const errorCreatePayment = state => state.errorCreatePayment.data
const isLoadingCreatePayment = state => state.isLoadingCreatePayment

const dataTemp = state => state.dataTemp

const getPaymentDetail = state => state.getPaymentDetail.data
const errorPaymentDetail = state => state.errorPaymentDetail.data
const isLoadingPaymentDetail = state => state.isLoadingPaymentDetail

const getPaymentHistory = state => state.getPaymentHistory.data
const errorPaymentHistory = state => state.errorPaymentHistory.data
const isLoadingPaymentHistory = state => state.isLoadingPaymentHistory

const putPartialProof = state => state.putPartialProof.data
const errorPartialProof = state => state.errorPartialProof.data
const isLoadingPartialProof = state => state.isLoadingPartialProof

export default {
  isLoading,
  isDownloading,
  errorDownloading,
  items,
  error,
  item,
  count,

  unpaidFilter,
  errorUnpaidFilter,
  isLoadingUnpaidFilter,

  paymentWaiting,
  errorpaymentWaiting,
  isLoadingpaymentWaiting,

  paymentPartial,
  errorpaymentPartial,
  isLoadingpaymentPartial,

  paymentComplete,
  errorpaymentComplete,
  isLoadingpaymentComplete,

  createPayment,
  errorCreatePayment,
  isLoadingCreatePayment,

  dataTemp,

  getPaymentDetail,
  errorPaymentDetail,
  isLoadingPaymentDetail,

  getPaymentHistory,
  errorPaymentHistory,
  isLoadingPaymentHistory,

  putPartialProof,
  errorPartialProof,
  isLoadingPartialProof
}



// WEBPACK FOOTER //
// ./src/store/modules/payment/getters.js